import get from 'lodash/fp/get'
import isEmpty from 'lodash/isEmpty'
import * as Elasticsearch from '../../../elasticsearch'
import * as Counters from '../counters'
import * as Types from './types'

const toTopSource = (bucket: any): Types.TopSource => {
  const postTypes = get(Elasticsearch.DocumentFieldNames.PostType, bucket)
  const recommended = Counters.firstEntry(postTypes, 'recommendation')

  return {
    click: Counters.newCounterEntry(bucket),
    recommended: Counters.newCounterEntry(recommended),
    sourceName: bucket.key,
  }
}

export const getTopSources = (payload: any): Types.TopSource[] => {
  return get(`aggregations.source_name.buckets`, payload)
          .map((bucket: any) => toTopSource(bucket))
}

const toSourceOpen = (bucket: any): Types.TopSource => {
  const unique = get(Elasticsearch.AggFieldNames.UniqueCount, bucket)
  return {
    open: {
      total: {
        count: bucket[Elasticsearch.AggFieldNames.DocumentCount],
      },
      unique: {
        count: unique ? unique.value : bucket[Elasticsearch.AggFieldNames.DocumentCount],
      },
    },
    sourceName: bucket.key,
  }
}

export const getSourceOpens = (payload: any): Types.TopSource[] => {
  return get(`aggregations.source_name.buckets`, payload)
          .map((bucket: any) => toSourceOpen(bucket))
}

export const updateTopSourceOpens = (input: Types.TopSource, newData: Types.TopSource[]): Types.TopSource => {
  return isEmpty(newData) ? input : {
    ...input,
    click: Counters.updateUniqueRateFromOpens(input.click, newData[0].open),
    open: newData[0].open,
    recommended: Counters.updateUniqueRateFromOpens(input.recommended, input.click),
  }
}

export const updateTopSourceData = (input: Types.TopSource, newData: Types.TopSource[]): Types.TopSource => {
  return isEmpty(newData) ? input : {
    ...input,
    sourceName: newData[0].sourceName || input.sourceName,
    title: newData[0].title || input.title || newData[0].url,
    url: newData[0].url || input.url,
  }
}



// WEBPACK FOOTER //
// ./src/pages/reports/top-sources/utils.ts